import { MegaMenuLink } from './MegaMenuLink';

export default MegaMenuLink;
